export const rewriteUrl = (
  identifier: string,
  relative: boolean = false
): string => {
  const PEBBLE_NEWS_VIEWER = `api/v1/news/article/`;
  const host = relative && import.meta.env.DEV ? "" : "https://pebble.finance";

  // Check for new format: api/v1/news/article/
  if (identifier.includes("api/v1/news/article/")) {
    // Strip the domain if relative is requested
    if (relative && import.meta.env.DEV && identifier.startsWith("https://")) {
      return identifier.replace(/^https?:\/\/[^/]+\//, "/");
    }
    return identifier;
  }

  // Check for provider-specific format: api/v1/news/providers/{provider}/uuid/
  if (
    identifier.includes("api/v1/news/providers/") &&
    identifier.includes("/uuid/")
  ) {
    // Strip the domain if relative is requested
    if (relative && import.meta.env.DEV && identifier.startsWith("https://")) {
      return identifier.replace(/^https?:\/\/[^/]+\//, "/");
    }
    return identifier;
  }

  // Fallback: assume it's a UUID and use the new format
  return `${host}/${PEBBLE_NEWS_VIEWER}${identifier}`;
};
